import _ from "lodash";

export default function SbShareOptionsCtrl(
    $window,
    $mdToast,
    $mdPanel,
    $translate,
    $sbMembership,
    mdPanelRef,
    Analytics
) {
    "ngInject";

    var vm = this;

    vm.copyToClipboard = copyToClipboard;
    vm.shareViaEmail = shareViaEmail;
    vm.shareViaMSTeams = shareViaMSTeams;
    vm.shareViaWhatsApp = shareViaWhatsApp;

    function getCurrentUrl() {
        return $window.location.href;
    }

    function copyToClipboard() {
        Analytics.trackConversion("Shared via Clipboard");
        const url = getCurrentUrl();

        navigator.clipboard.writeText(url).then(() => {
            mdPanelRef.close();

            // Show toast notification
            $mdToast.show(
                $mdToast
                    .simple()
                    .content(
                        $translate.instant("SHARE_COPY_TO_CLIPBOARD_TOAST")
                    )
                    .position("top right")
                    .hideDelay(3000)
            );
        });
    }

    function shareViaEmail() {
        Analytics.trackConversion("Shared via Email");
        const url = getCurrentUrl();

        const subject = $translate.instant("SHARE_VIA_EMAIL_SUBJECT", {
            name: _.get($sbMembership.current(), "user.displayName"),
        });
        const body = $translate.instant("SHARE_VIA_EMAIL_TEXT", {
            name: _.get($sbMembership.current(), "user.displayName"),
            linkToPage: encodeURIComponent(url),
        });
        $window.open(`mailto:?subject=${subject}&body=${body}`, "_blank");
    }

    function shareViaMSTeams() {
        Analytics.trackConversion("Shared via MS Teams");
        const url = getCurrentUrl();
        $window.open(
            `https://teams.microsoft.com/share?href=${encodeURIComponent(url)}`,
            "_blank"
        );
    }

    function shareViaWhatsApp() {
        Analytics.trackConversion("Shared via WhatsApp");
        const url = getCurrentUrl();
        $window.open(
            `https://api.whatsapp.com/send?text=${encodeURIComponent(url)}`,
            "_blank"
        );
    }
}
